import Cookies from 'js-cookie';

const addCookiePlugin = ($: JQueryStatic) => {
  // temporary stub for replacing $.cookie plugin with js-cookie
  // this will be removed once the jQuery usage is removed
  $.extend({
    cookie: function (
      key: string,
      value: string,
      options: JQueryCookieOptions,
    ) {
      if (key && value) {
        Cookies.set(key, value, options);
        return true;
      } else if (key) {
        return Cookies.get(key);
      } else {
        return false;
      }
    },
  });
};

export { addCookiePlugin };
